import { API } from 'aws-amplify';
import axios from 'axios';

export function updateConfigTw(queryStringParameters:any, body)
{
	return API.put('userManagement', '/user', { queryStringParameters, body });
}
export function getConfigDetails(queryStringParameters)
{
	return API.get('userManagement', '/getEmployees', { queryStringParameters });
}
export function getOtherEmployees(queryStringParameters:any)
{
	return API.get('taskManagement', '/getEmployee', { queryStringParameters });
}
export function updateAcces(body)
{
	return API.put('userManagement', '/employeeUpdate', { body });
}
export function getRelationsCounts(queryStringParameters)
{
	return API.get('folderManagement', '/getConnectedUserCounts', { queryStringParameters });
}
export function getMeetingsList(queryStringParameters)
{
	return API.get('folderManagement', '/meeting', { queryStringParameters });
}
export function getWebinarsList(queryStringParameters)
{
	return API.get('folderManagement', '/meeting', { queryStringParameters });
}
export function getWebinarCalendarData(queryStringParameters)
{
	return API.get('folderManagement', '/calendarMeetingsCount', { queryStringParameters });
}
export function getCalenderCount(queryStringParameters)
{
	return API.get('folderManagement', '/calendarMeetingsCount', { queryStringParameters });
}

export function fetchWebinarAnalyticsCount(queryStringParameters)
{
	return API.get('folderManagement', '/indexAnalytics', { queryStringParameters });
}

export function createSpeakerFunc(body)
{
	return API.post('folderManagement', '/speakers', { body });
}
export function editSpeakerFunc(body)
{
	return API.put('folderManagement', '/speakers', { body });
}
export function deleteSpeakerFunc(queryStringParameters)
{
	return API.del('folderManagement', '/speakers', { queryStringParameters });
}
export function createMeeting(body)
{
	return API.post('folderManagement', '/meeting', { body });
}
export function updateMeeting(body)
{
	return API.put('folderManagement', '/meeting', { body });
}
export function createSurvey(body)
{
	return API.post('folderManagement', '/survey', { body });
}
export function deleteSurvey(queryStringParameters)
{
	return API.del('folderManagement', '/survey', { queryStringParameters });
}
export function getSurveyDetails(queryStringParameters)
{
	return API.get('folderManagement', '/survey', { queryStringParameters });
}
export function CreateMeetings(body:any)
{
	return API.post('folderManagement', '/meeting', { body });
}
export function getSpeakersList(queryStringParameters)
{
	return API.get('folderManagement', '/speakers', { queryStringParameters });
}
export const getRegistrations = (queryStringParameters) =>
{
	return API.get('folderManagement', '/register', { queryStringParameters });
};
export const getMeetingVerification = (queryStringParameters) =>
{
	return API.get('folderManagement', '/verify', { queryStringParameters });
};
export const getMeetingGraph = (queryStringParameters) =>
{
	return API.get('folderManagement', '/indexAnalytics', { queryStringParameters });
};
export const getLocationsData = (queryStringParameters) =>
{
	return axios.get(`${process.env.REACT_APP_INMEET}/location`, { params: queryStringParameters });
	// return API.get('inmeetAanalytics', '/deviceandlocation', { queryStringParameters });
};

export function deviceAndLocation(body)
{
	return API.post('inmeetAanalytics', '/deviceandlocation', { body });
}
export const createPoll = (body) =>
{
	return API.post('folderManagement', '/polling', { body });
};

export const getPolling = (queryStringParameters) =>
{
	return API.get('folderManagement', '/polling', { queryStringParameters });
};

export const updatePolling = (body) =>
{
	return API.put('folderManagement', '/polling', { body });
};

export const deletePolling = (queryStringParameters) =>
{
	return API.del('folderManagement', '/polling', { queryStringParameters });
};

export const getRecordingList = (queryStringParameters) =>
{
	return API.get('folderManagement', '/getRecordingView', { queryStringParameters });
};
export const UpdatePendingRegistation = (body) =>
{
	return API.put('folderManagement', '/register', { body });
};
export const CreateRegistration = (body) =>
{
	return API.post('folderManagement', '/register', { body });
};

export const OverlapMeeting = (body) =>
{
	return API.post('folderManagement', '/overlap', { body });
};
export const JoinOnGngMeeting = () =>
{
	return API.get('folderManagement', '/joinOngoingMeet', {});
};
export const getPastMeetingParticipantsList = (queryStringParameters) =>
{
	return API.get('folderManagement', '/getParticipants', { queryStringParameters });
};

export const publishSummary = (body) =>
{
	return API.put('folderManagement', '/meeting', { body });
};

export const getSuveyResAnalytics = (queryStringParameters) =>
{
	return API.get('folderManagement', '/surveyResponse', { queryStringParameters });
};
export const getAttendeesCount = (queryStringParameters) =>
{
	return API.get('folderManagement', '/indexAnalytics', { queryStringParameters });
};
export const getPollingData = (pathParams) =>
{
	return axios.get(`${process.env.REACT_APP_PASSMEETINGS_INMEET}/getpollresults/${pathParams}`);
};
export const getPublicMeetingData = (queryStringParameters) =>
{
	return axios.get(`${process.env.REACT_APP_MEETING_PUBLIC_API}/publicAPI`, { params: queryStringParameters });
};
export const getAllChats = (queryStringParameters) =>
{
	return axios.get(`${process.env.REACT_APP_ALL_CHATS}/getAllChat`, { params: queryStringParameters });
};
export const getTranscActionsSummary = (queryStringParameters) =>
{
	return axios.get(`${process.env.REACT_APP_GET_TRANSCRIPTION_ORG_AUTO_SUMMARY}/transcription`, { params: queryStringParameters });
};

export const updateTranscActionsSummary = (body, queryStringParameters) =>
{
	return axios.put(`${process.env.REACT_APP_GET_TRANSCRIPTION_ORG_AUTO_SUMMARY}/transcription`, body, { params: queryStringParameters });
};

export const checkShareId = (params) =>
{
	return axios.get(`${process.env.REACT_APP_SHARESCREEN_INMEET}/getroomid/`, { params });
	// return axios.get('https://10.10.30.108:3443/auth/getroomid/', { params });
};
// export function getPastRecording(query:any, md5Hash:any)
// {
// 	return API.get('pastmeetingrecording', `/getsessionlogs${query}`, 	{
// 		maxBodyLength : Infinity
// 	});
// }

export function getPastRecording(query, md5Hash)
{
	const config = {
		headers : {
			Authorization  : `Bearer ${md5Hash}`,
			'Content-Type' : 'application/json'
		}
	};

	return API.get('pastmeetingrecording', `/getSessionStatusInfo${query}`, config);
}

export function GetReactions(queryStringParameters)
{
	return API.get('inmeetAanalytics', '/reactions', { queryStringParameters });
}

export const createRecordingStatus = (body) =>
{
	return API.post('folderManagement', '/createRecordingView', { body });
};
export function CreateMeetingsForPresence(body:any)
{
	return API.post('folderManagement', '/meeting/presence', { body });
}